export default function CAuto() {
  return <h2>C Auto</h2>;
}
